(function() {
  const DISCOUNT_URL = 'https://lupicoffee.com/discount/DISCO3?redirect=/checkout';
  const TRIGGER_VARIANTS = [54039681204553, 54039681270089]; // 3x moulu, 3x grains

  async function cartHasTriggerVariant() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return cart.items.some(item =>
        TRIGGER_VARIANTS.includes(Number(item.variant_id))
      );
    } catch (e) {
      console.error('DISCO3 check failed', e);
      return false;
    }
  }

  function attachHandler() {
    const btn = document.querySelector('.easc-checkoutBtn');
    if (!btn || btn.dataset.discoHandlerAttached === 'true') return;

    btn.dataset.discoHandlerAttached = 'true';

    btn.addEventListener('click', async function(e) {
      e.preventDefault();

      const qualifies = await cartHasTriggerVariant();

      if (qualifies) {
        window.location.href = DISCOUNT_URL;
      } else {
        // Fallback: normal checkout
        window.location.href = '/checkout';
      }
    });
  }

  // Run once on load
  document.addEventListener('DOMContentLoaded', attachHandler);

  // Re-run when EA Sticky updates the cart/drawer
  ['cart:updated', 'easc:drawer:open', 'easc:cart:rendered'].forEach(eventName => {
    document.addEventListener(eventName, attachHandler);
  });
})();
